import React from 'react';

const ExecutiveSummary = ({ displayData, sampleDataFallback }) => (
  <div className="space-y-6">
    {/* Large Savings Tile */}
    <div
      className={`text-white p-8 rounded-lg text-center ${
        displayData.isRealAnalysis
          ? 'bg-emerald-600 dark:bg-emerald-500'
          : 'bg-slate-600 dark:bg-slate-700'
      }`}
    >
      <div className="flex items-center justify-center gap-3 mb-2">
        <h2 className="text-2xl font-bold">
          {displayData.isRealAnalysis ? 'REAL Calculated' : 'Sample'} Annual
          Savings
        </h2>
        {displayData.isRealAnalysis && (
          <span className="text-emerald-200 dark:text-emerald-300 text-lg">
            ✅
          </span>
        )}
      </div>
      <p className="text-6xl font-bold">
        ${displayData.annualSavings.toLocaleString()}
      </p>
      <p className="text-xl mt-2">
        From {displayData.measuresCount} identified opportunities
      </p>
      {displayData.isRealAnalysis && (
        <p className="text-sm mt-2 text-emerald-200 dark:text-emerald-300">
          Based on equipment profiles & professional engineering calculations
        </p>
      )}
    </div>

    {/* Metrics Row */}
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <div className="bg-emerald-100 dark:bg-emerald-900/30 p-6 rounded-lg text-center border border-emerald-200 dark:border-emerald-700">
        <p className="text-3xl font-bold text-emerald-700 dark:text-emerald-400">
          {displayData.energySaved.toLocaleString()}
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          kWh/year Energy Saved
        </p>
        {displayData.isRealAnalysis && (
          <p className="text-xs text-emerald-600 dark:text-emerald-400 mt-1">
            ✓ Real calculation
          </p>
        )}
      </div>
      <div className="bg-blue-100 dark:bg-blue-900/30 p-6 rounded-lg text-center border border-blue-200 dark:border-blue-700">
        <p className="text-3xl font-bold text-blue-700 dark:text-blue-400">
          {displayData.measuresCount}
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Opportunities Identified
        </p>
        {displayData.isRealAnalysis && (
          <p className="text-xs text-blue-600 dark:text-blue-400 mt-1">
            ✓ Equipment-based
          </p>
        )}
      </div>
      <div className="bg-slate-100 dark:bg-slate-800 p-6 rounded-lg text-center border border-slate-200 dark:border-slate-700">
        <p className="text-3xl font-bold text-slate-700 dark:text-slate-300">
          {displayData.paybackPeriod}
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Years Payback Period
        </p>
        {displayData.isRealAnalysis && (
          <p className="text-xs text-slate-600 dark:text-slate-400 mt-1">
            ✓ Financial modeling
          </p>
        )}
      </div>
      <div className="bg-emerald-100 dark:bg-emerald-900/30 p-6 rounded-lg text-center border border-emerald-200 dark:border-emerald-700">
        <p className="text-3xl font-bold text-emerald-700 dark:text-emerald-400">
          {displayData.roi}%
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-400">Annual ROI</p>
        {displayData.isRealAnalysis && (
          <p className="text-xs text-emerald-600 dark:text-emerald-400 mt-1">
            ✓ Professional ROI
          </p>
        )}
      </div>
    </div>

    {/* REAL vs Sample Indicator */}
    {displayData.isRealAnalysis && (
      <div className="bg-emerald-50 dark:bg-emerald-900/20 border-2 border-emerald-200 dark:border-emerald-700 rounded-lg p-4">
        <div className="flex items-center gap-3">
          <span className="text-2xl">✅</span>
          <div>
            <h3 className="text-lg font-bold text-emerald-800 dark:text-emerald-300">
              REAL Professional Analysis
            </h3>
            <p className="text-emerald-700 dark:text-emerald-400">
              These metrics are calculated using our professional equipment-based
              analysis engine, not generic sample data. This demonstrates the
              sophistication of our $990 methodology.
            </p>
          </div>
        </div>
      </div>
    )}

    {/* Premium Feature Preview */}
    <div className="bg-gradient-to-r from-purple-50 to-indigo-50 dark:from-purple-900/20 dark:to-indigo-900/20 border-2 border-purple-200 dark:border-purple-700 rounded-lg p-6">
      <h3 className="text-lg font-bold text-purple-800 dark:text-purple-300 mb-2">
        🚀 Premium Features Available
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
        <div className="text-center">
          <p className="font-semibold text-purple-700 dark:text-purple-400">
            +{sampleDataFallback.productivityRoadmap.cumulativeImpact.totalGain}%
          </p>
          <p className="text-gray-600 dark:text-gray-400">
            Productivity Improvement
          </p>
        </div>
        <div className="text-center">
          <p className="font-semibold text-purple-700 dark:text-purple-400">
            {sampleDataFallback.improvedPercentile}th
          </p>
          <p className="text-gray-600 dark:text-gray-400">
            Percentile (Post-Implementation)
          </p>
        </div>
        <div className="text-center">
          <p className="font-semibold text-purple-700 dark:text-purple-400">
            18-Month
          </p>
          <p className="text-gray-600 dark:text-gray-400">
            Implementation Roadmap
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default ExecutiveSummary;


